import { isValidJSON } from "utils";

export const errorReducer = (payload: any): string[] => {
  const actionPayload = isValidJSON(payload) ? JSON.parse(payload) : payload;
  const errorMessages: string[] = [];
  if (actionPayload?.message === "Validation Errors") {
    let payloadErrors: any = {};
    if (actionPayload?.errors) {
      payloadErrors = { ...actionPayload?.errors };
    } else if (actionPayload?.data?.errors) {
      payloadErrors = { ...actionPayload?.data?.errors };
    } else if (actionPayload?.data?.responses) {
      payloadErrors = { ...actionPayload?.data?.responses };
    }

    Object.keys(payloadErrors).forEach(function (key) {
      for (let i = 0; i < payloadErrors[key].length; i++) {
        // customErrorToast({ message: payloadErrors[key][i] });
        errorMessages.push(payloadErrors[key][i]);
      }
    });
  } else if (actionPayload?.validationErrors !== undefined) {
    const errors = actionPayload?.validationErrors;

    if (typeof errors === "string") {
      //   customErrorToast({ message: errors });
      errorMessages.push(errors);
    } else if (Array.isArray(errors)) {
      for (let i = 0; i < errors.length; i++) {
        // customErrorToast({ message: errors[i] });
        errorMessages.push(errors[i]);
      }
    }
  }
  return errorMessages;
};
